module.exports = __webpack_public_path__ + "assets/img/teacher (58).471ab88b.png";